import { render, staticRenderFns } from "./Saletrade.vue?vue&type=template&id=aecc625c&scoped=true"
import script from "./Saletrade.vue?vue&type=script&lang=js"
export * from "./Saletrade.vue?vue&type=script&lang=js"
import style0 from "./Saletrade.vue?vue&type=style&index=0&id=aecc625c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecc625c",
  null
  
)

export default component.exports